// frontend/src/pages/SalesChatWidget.jsx
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom"; // Added to detect navigation changes
import { Button } from "../ui/UIComponents";

// 1. ANH MẠNH'S "FORCE OF BUDDIES" LIBRARY (ULTIMATE EDITION)
const WISDOM_QUOTES = [
  // =========================================================================
  // PHẦN 1: ĐỐI NHÂN XỬ THẾ & ĐỒNG NGHIỆP (OFFICE RELATIONSHIPS)
  // =========================================================================
  "Đồng nghiệp là người cùng thuyền. Đừng đục thuyền khi đang ra khơi nha mấy đứa.",
  "Muốn đi nhanh thì đi một mình, muốn chốt đơn to thì phải rủ đồng đội đi cùng! Teamwork là sức mạnh.",
  "Sống ở công sở, 'xởi lởi' thì trời cho. So đo quá thì... trời co lại đấy.",
  "Cười với nhau một cái, việc khó cũng thành dễ. Cau có thì việc dễ cũng thành khó.",
  "Đừng nói xấu sau lưng, vì Trái Đất tròn lắm, lỡ người ta quay lại là mình... quê đó.",
  "Làm sales mà không có 'hậu phương' (CSKH, Kế toán, Kho) ủng hộ là gãy cánh. Nhớ mua trà sữa mời các chị em nhé!",
  "Thấy đồng nghiệp chốt được đơn to, đừng GATO mà hãy xin vía. Vía tốt nó lây, thật đấy!",
  "Hỗ trợ người khác lúc họ kẹt, lúc mình 'bí' số sẽ có người cứu. Luật nhân quả trong sales linh nghiệm lắm.",
  "Đừng tranh giành khách của bạn. Miếng bánh thị trường đủ lớn cho tất cả, ăn một mình hay bị nghẹn.",
  "Khi đồng nghiệp gặp khó khăn, một câu hỏi thăm 'Ổn không bà?' giá trị hơn ngàn lời sáo rỗng.",
  "Sếp mắng thì nghe, đừng cãi tay đôi lúc nóng. Đợi sếp nguội rồi anh em ra ban công tâm sự sau.",
  "Đừng mang 'rác' cảm xúc từ nhà đến công ty, và đừng mang áp lực công ty về nhà trút lên người thân.",
  "Biết ơn người dẫn dắt mình. Không có người đi trước dọn đường, mình đi vấp đá sưng chân ráng chịu.",
  "Lời nói chẳng mất tiền mua. Khen đồng nghiệp bộ đồ đẹp, khen cái idea hay... không tốn calo đâu.",
  "Sai thì nhận, đừng đổ lỗi. Người dám nhận sai là người trưởng thành, ai cũng nể.",
  "Trong cuộc họp, tranh luận là để ra vấn đề, không phải để thắng thua. Ra khỏi phòng họp là lại anh em.",
  "Giữ lời hứa với đồng nghiệp cũng quan trọng như giữ uy tín với khách hàng vậy.",
  "Đừng làm 'Camera chạy bằng cơm'. Việc ai người nấy làm, bớt soi mói đời tư người khác.",
  "Chia sẻ kiến thức không làm em nghèo đi. Giấu nghề mới làm mình dậm chân tại chỗ.",
  "Văn hóa công ty là do chính em tạo ra. Em vui vẻ, công ty vui vẻ.",
  "Đừng để cái tôi to hơn cái túi. Hạ cái tôi xuống để học hỏi từ những bạn trẻ hơn, họ giỏi lắm đấy.",
  "Có món gì ngon thì mang lên mời cả phòng. Đường đến trái tim đồng nghiệp đi qua... dạ dày.",
  "Khi em tôn trọng người khác, em đang tự tôn trọng chính mình.",
  "Đừng 'chia bè kết phái'. Chúng ta cùng một phe: Phe kiếm tiền từ thị trường, không phải phe đấu đá nội bộ.",
  "Nhìn vào điểm tốt của người khác mà sống. Nhìn điểm xấu chỉ tổ làm mình khó chịu.",
  "Giúp đỡ người mới (Newbie). Ngày xưa em cũng từng ngơ ngác như họ mà.",
  "Tôn trọng sự khác biệt. Mỗi người một tính cách, ghép lại mới thành bức tranh hoàn hảo.",
  "Thẳng thắn nhưng phải khéo léo. 'Sự thật mất lòng' nhưng nói khéo thì được lòng đôi bên.",
  "Làm việc có tâm, ắt có tầm. Đồng nghiệp họ nhìn vào kết quả và thái độ của em để đánh giá.",
  "Đừng hứa lèo. Mượn cái dập ghim cũng phải trả đúng chỗ. Uy tín từ việc nhỏ.",
  "Cuối tuần rủ nhau đi làm cốc bia, xả hết chuyện công việc. Thứ 2 lại chiến đấu tiếp!",

  // =========================================================================
  // PHẦN 1: SỰ THẬT MẤT LÒNG (SAVAGE TRUTHS)
  // =========================================================================
  "Khách hàng là Thượng Đế. Nhưng nhớ là Thượng Đế cũng có lúc... nhầm lẫn. Nhẹ nhàng mà sửa lưng họ nhé.",
  "Tiền không mua được hạnh phúc? Chắc do em chưa biết chỗ mua thôi. Cày tiếp đi!",
  "Deadline là cái vạch kẻ ra để chúng ta bước qua... vào ngày hôm sau. (Đùa thôi, sếp nghe thấy là chết đấy).",
  "Đừng tranh cãi với khách hàng. Dù em thắng lý lẽ, em cũng thua cái ví tiền của họ.",
  "Lương tâm nghề nghiệp không cho phép mình làm ẩu. Nhưng lương thực tế thì... ừm, tùy tâm trạng.",
  "Muốn đi nhanh thì đi một mình. Muốn đổ lỗi cho người khác khi sai... thì phải đi cùng đồng đội.",
  "Sáng tạo là tốt, nhưng đừng sáng tạo số liệu trong báo cáo doanh số. Cái đó gọi là 'bốc phét'.",
  "Nếu kế hoạch A thất bại, đừng lo. Bảng chữ cái còn 28 chữ cái nữa cơ mà.",
  "Đừng buồn vì hôm nay ế khách. Vì ngày mai có thể... còn ế hơn. Lạc quan lên!",
  "Kinh nghiệm là cái thứ mình chỉ có được ngay sau khi vừa làm sai cái gì đó.",
  "Làm Sales là nghệ thuật 'móc túi' khách hàng mà khiến họ cười tươi roi rói. Em đã đạt cảnh giới đó chưa?",
  "Thái độ quan trọng hơn trình độ? Sai rồi. Thái độ lồi lõm thì có trình độ trời cũng ra đường.",
  "Đừng bao giờ đánh giá thấp sức mạnh của những người ngu ngốc nhưng lại có tiền. Đó là khách VIP đấy.",
  "Cuộc đời này công bằng lắm. Em làm nhiều... thì sếp giàu. Cố lên!",

  // =========================================================================
  // PHẦN 2: KỸ NĂNG & TƯ DUY CHIẾN ĐẤU (SALES WISDOM)
  // =========================================================================
  "Bán hàng là bán mình trước, bán sản phẩm sau. Uy tín là cái vốn lớn nhất của em.",
  "Khách từ chối không phải là 'thất bại', mà là 'chưa đúng lúc'. Kiên nhẫn là mẹ thành công.",
  "Đừng bán cái em có, hãy bán giải pháp cho nỗi đau của khách hàng. Gãi đúng chỗ ngứa thì tiền rơi.",
  "Chốt đơn là nghệ thuật, nhưng chăm sóc sau bán mới là đẳng cấp. Khách cũ nuôi sống mình đấy.",
  "Zig Ziglar từng nói: 'Thái độ quan trọng hơn trình độ'. Kỹ năng học được, nhưng sự chân thành thì không.",
  "Đừng đợi khách hàng hỏi mới trả lời. Hãy hiểu họ cần gì trước cả khi họ mở miệng.",
  "Sales không phải là ép khách mua, mà là giúp khách ra quyết định đúng đắn nhất.",
  "Báo giá xong mà im lặng là dở rồi. Phải có 'cớ' để nhắn tin lại: Chúc tuần mới, gửi tin tức, hỏi thăm...",
  "Đừng giảm giá để chốt đơn, hãy tăng giá trị để khách thấy rẻ. Bán rẻ là tự cắt thịt mình.",
  "Khách hàng mua bằng cảm xúc và biện minh bằng logic. Hãy làm họ 'sướng' trước đã.",
  "Brian Tracy bảo rồi: 'Tiếp cận mỗi khách hàng với ý nghĩ giúp họ giải quyết vấn đề, chứ không phải để bán hàng'.",
  "Đừng sợ lời từ chối. Mỗi lần lắc đầu là một bước gần hơn đến cái gật đầu.",
  "Lắng nghe 80%, nói 20%. Ai nói nhiều người đó thua. Để khách nói, mình mới hiểu họ cần gì.",
  "Đừng hứa những gì mình không làm được. Hứa 10 làm 12 thì khách thương, hứa 10 làm 8 là khách đi luôn.",
  "Theo đuổi đam mê, thành công sẽ theo đuổi bạn? Không, theo đuổi khách hàng, tiền sẽ theo đuổi bạn! :))",
  "Chuẩn bị kỹ lưỡng là 50% chiến thắng. Đừng tay không bắt giặc.",
  "Sự im lặng của khách hàng đáng sợ hơn lời chê bai. Hãy tìm cách phá vỡ sự im lặng đó.",
  "Đừng bao giờ tranh cãi với khách hàng. Em thắng lý lẽ, nhưng em thua đơn hàng.",
  "Nụ cười qua điện thoại cũng nghe thấy được. Nhấc máy lên là phải tươi!",
  "Khách hàng không mua sản phẩm, họ mua sự an tâm. Em có làm họ an tâm không?",
  "Chăm sóc khách hàng là trồng cây. Đừng mong gieo hạt hôm nay mai hái quả ngay.",
  "Đối thủ cạnh tranh không đáng sợ. Đáng sợ là mình không chịu thay đổi.",
  "Hãy coi lời phàn nàn của khách là món quà. Đó là cơ hội để mình hoàn thiện dịch vụ.",
  "Đừng bán hàng như một cái máy. Hãy bán hàng như một người bạn tâm giao.",
  "Quy luật 80/20: 80% doanh số đến từ 20% khách hàng VIP. Chăm cho kỹ vào!",
  "Đừng bao giờ nói xấu đối thủ trước mặt khách. Điều đó chỉ làm mình trông kém sang thôi.",
  "Tốc độ phản hồi là vũ khí. Khách hỏi mà 3 tiếng sau mới rep là mất khách rồi.",
  "Kiến thức sản phẩm phải nắm trong lòng bàn tay. Khách hỏi gì cũng ú ớ thì ai dám mua?",
  "Hãy xin lời giới thiệu (Referral). Một lời giới thiệu uy tín hơn ngàn lời quảng cáo.",
  "Jordan Belfort (Sói Già) nói: 'Cách duy nhất để giàu có là thuyết phục người khác rằng bạn có thứ họ cần'.",
  "Cuối tháng chưa đủ số? Thở sâu, uống miếng nước, rồi gọi lại danh sách khách cũ. Phép màu nằm ở đó.",

  // =========================================================================
  // PHẦN 2: CHIẾN THUẬT "MẶT DÀY" (STREET SMART SALES)
  // =========================================================================
  "Khách bảo 'Để anh xem xét lại' nghĩa là 90% 'Anh lượn đây'. Đừng tin, dí tiếp đi!",
  "Bí quyết thành công là dậy sớm? Không, bí quyết là dậy sớm và tìm ra đứa nào đang ngủ để bán hàng cho nó.",
  "Nếu không thể thuyết phục khách bằng kiến thức, hãy làm họ hoang mang bằng sự nhiệt tình thái quá.",
  "Đừng hứa 'Bảo hành trọn đời'. Đời em hay đời khách? Hay đời cái rèm? Nói cho rõ vào.",
  "Đối thủ giảm giá? Kệ họ. Hàng hiệu không bao giờ Sale off kiểu hàng chợ. Giữ giá, giữ sang chảnh!",
  "Khi khách chê đắt, đừng giảm giá. Hãy hỏi: 'Thế anh thích rẻ hay thích xịn?'. Đánh vào lòng tự trọng là móc được ví.",
  "Gọi điện telesales mà bị chửi? Cười lên. Ít nhất họ còn bắt máy, đỡ hơn là bị 'Ghost'.",
  "Đừng bán cái khách cần (đôi khi họ chả biết họ cần gì đâu). Bán cái mà họ 'tưởng' là họ cần ấy.",
  "Nụ cười là vũ khí miễn phí. Nhưng dùng nhiều quá người ta tưởng mình... có vấn đề đấy. Tiết chế thôi.",
  "Quy tắc vàng: Nếu không giải quyết được vấn đề, hãy giải quyết người nêu ra vấn đề. (Đùa thôi, đừng block khách nhé).",
  "Hãy sống như một con tem: Dính chặt vào mục tiêu (khách hàng) cho đến khi đến đích (chốt đơn).",
  "Đừng làm việc chăm chỉ, hãy làm việc thông minh. Nhưng trong lúc sếp đi qua thì nhớ làm bộ chăm chỉ.",

  // =========================================================================
  // PHẦN 3: ĐỘNG LỰC, SỨC KHỎE & DANH NGÔN (LIFE & ATTITUDE)
  // =========================================================================
  "Cuộc sống sales áp lực thật, nhưng lúc 'hoa hồng' về tài khoản thì mọi nỗi buồn đều tan biến!",
  "Hôm nay trời đẹp, sao em lại buồn? Cười lên cái nào, may mắn tự nhiên tới.",
  "Jack Ma từng bảo: 'Hôm nay khó khăn, ngày mai còn tồi tệ hơn, nhưng ngày kia sẽ là ngày tuyệt vời'. Cố lên!",
  "Đừng mang áp lực doanh số về nhà. Bước ra khỏi cửa công ty là phải vui với gia đình.",
  "Thất bại chỉ là học phí. Đóng học phí rồi thì phải học cho khôn ra nhé.",
  "Sức khỏe là số 1, công việc là số 0. Không có số 1 thì bao nhiêu số 0 phía sau cũng vô nghĩa. Nhớ ăn đúng bữa.",
  "Steve Jobs nói: 'Cách duy nhất để làm việc tuyệt vời là yêu những gì bạn làm'. Nếu chưa yêu, hãy tìm điểm đáng yêu của nó.",
  "Đừng so sánh mình với người khác. Hãy so sánh mình với hôm qua.",
  "Làm hết sức, chơi hết mình. Tối nay rảnh không? Làm cốc bia xả stress đi!",
  "Kỷ luật là cầu nối giữa mục tiêu và kết quả. Đừng nuông chiều sự lười biếng của bản thân.",
  "Không có áp lực, không có kim cương. Em đang trong quá trình mài dũa đấy.",
  "Hãy biết ơn những ngày khó khăn, vì nó làm em mạnh mẽ hơn.",
  "Thái độ lạc quan là thỏi nam châm thu hút cơ hội. Mặt ủ rũ thì thần tài cũng sợ chạy mất.",
  "Đừng chỉ làm việc chăm chỉ, hãy làm việc thông minh.",
  "Cuộc đời này ngắn lắm, đừng dành thời gian để ghét bỏ hay giận hờn. Tập trung kiếm tiền và yêu thương đi.",
  "Khi em muốn bỏ cuộc, hãy nhớ lại lý do tại sao em bắt đầu.",
  "Tiền không mua được hạnh phúc, nhưng khóc trong xe Mercedes vẫn hơn khóc trên xe đạp. Cày thôi em ơi!",
  "Ngủ đủ giấc cũng là một loại năng lực. Đừng thức khuya cày phim nữa, hại não lắm.",
  "Đọc sách đi. 30 phút mỗi ngày thôi. Những gì em nạp vào đầu sẽ quyết định độ dày ví của em.",
  "Hãy cho đi trước khi muốn nhận lại. Cuộc đời này sòng phẳng lắm.",
  "Vấp ngã không phải là thất bại. Nằm lì ở đó mới là thất bại.",
  "Tự tin là trang phục đẹp nhất em có thể mặc. Hãy ngẩng cao đầu lên.",
  "Đừng sợ thay đổi. Bạn không thể mong kết quả mới với cách làm cũ rích được.",
  "Thành công không đến qua đêm. Nó là kết quả của việc tốt hơn 1% mỗi ngày.",
  "Hãy là chính mình phiên bản tốt nhất, đừng cố làm bản sao của người khác.",
  "Đôi khi, việc dũng cảm nhất em làm trong ngày chỉ đơn giản là tiếp tục bước đi.",
  "Hạnh phúc không phải là đích đến, nó là hành trình. Vừa làm sales vừa tận hưởng niềm vui chốt đơn nhé.",
  "Warren Buffett nói: 'Đầu tư càng nhiều vào bản thân mình càng tốt'. Em là tài sản lớn nhất.",
  "Mệt thì nghỉ chút, đừng bỏ cuộc. Mai trời lại sáng, khách lại rep tin nhắn thôi.",
  "Hãy tử tế với mọi người gặp trên đường leo lên đỉnh cao, vì em sẽ gặp lại họ khi trượt xuống dốc.",
  "Cuối cùng, hãy nhớ: Anh Mạnh luôn ở đây support em. Không biết gì cứ hỏi, đừng giấu dốt!",

  // =========================================================================
  // PHẦN 4: NGHỆ THUẬT ĐÀM PHÁN & THƯƠNG LƯỢNG (NEGOTIATION)
  // =========================================================================
  "Trong đàm phán, ai vội người đó thua. Cứ bình tĩnh, để khách 'nóng' trước.",
  "Đừng bao giờ chấp nhận lời đề nghị đầu tiên. Đó thường chỉ là phép thử của khách thôi.",
  "Quy tắc 'Nhượng bộ có điều kiện': Nếu em giảm giá, khách phải cho em cái gì? (Chốt ngay, thanh toán liền...). Đừng cho không.",
  "Sức mạnh của sự im lặng: Sau khi ra giá, hãy ngậm miệng lại. Người nói tiếp theo là người yếu thế hơn.",
  "Đàm phán là tìm điểm chung (Win-Win), không phải là vắt kiệt đối phương. Ép khách quá họ ký xong cũng hậm hực, lần sau chạy mất.",
  "Luôn chuẩn bị sẵn BATNA (Phương án thay thế). Nếu không chốt được deal này, em còn đường nào lui không? Có đường lui mới tự tin hét giá.",
  "Đừng để khách biết 'giá sàn' của em ngay từ đầu. Lộ bài sớm là bị ép đến chết.",
  "Khi khách chê đắt, đừng vội giảm giá. Hãy hỏi ngược lại: 'Ngoài giá ra, anh/chị còn lấn cấn gì không?'. Xử lý cái lấn cấn đó trước.",
  "Chiến thuật 'Kẻ đấm người xoa': Em cứ nhận là muốn giảm giá lắm nhưng 'Sếp khó tính' không duyệt. Đẩy vai ác cho anh (Mạnh)!",
  "Đừng thương lượng trên từng món lẻ tẻ. Hãy gói tất cả vào một combo rồi thương lượng trên tổng giá trị.",
  "Mềm nắn rắn buông. Thấy khách căng quá thì mình chùng xuống xoa dịu, thấy khách xuôi xuôi thì lấn tới chốt hạ.",
  "Đừng bao giờ nói 'Đây là giá cuối cùng' trừ khi đó THỰC SỰ là giá cuối cùng. Mất uy tín lắm.",
  "Hãy làm cho khách cảm thấy họ đã 'chiến thắng' trong cuộc đàm phán (dù thực ra em mới là người thắng).",
  "Tặng thêm quà (dịch vụ, phụ kiện) thay vì giảm tiền mặt. Giá trị cảm nhận cao hơn mà đỡ nát giá.",
  "Kiểm soát cảm xúc. Mặt lạnh tanh như tiền polime. Đừng để lộ sự vui sướng khi khách đồng ý quá sớm.",
  "Nếu khách so sánh giá với đối thủ, hãy tập trung vào sự khác biệt. 'Tiền nào của nấy anh ơi, bên em đắt xắt ra miếng'.",
  "Đừng ngại từ chối deal xấu. Thà không bán còn hơn bán lỗ vốn và ôm cục tức.",
  "Hãy dùng từ 'Chúng ta' thay vì 'Tôi' và 'Ông'. Tạo cảm giác đang cùng một phe giải quyết vấn đề giá cả.",

  // =========================================================================
  // PHẦN 3: TIẾNG ANH "CHỢ BÚA" (SLANG & JARGON)
  // =========================================================================
  "Học từ mới: 'ASAP' - Nghĩa là 'Làm ngay đi má'. Khi sếp chat cái này là phải chạy vắt chân lên cổ.",
  "Học từ mới: 'FYI' (For Your Information) - Nghĩa là 'Đọc đi cho khôn ra', thường dùng khi forward email chửi xéo.",
  "Học từ mới: 'CC' (Carbon Copy) - Nghĩa là 'Tao mách lẻo cho cả làng biết đấy', cẩn thận khi reply all.",
  "Học từ mới: 'Blue Sky Thinking' - Nghĩa là 'Mơ mộng hão huyền'. Sếp hay dùng để dụ dỗ anh em cày cuốc.",
  "Học từ mới: 'Low Hanging Fruit' - Nghĩa là 'Kèo thơm'. Thấy khách dễ tính là phải vặt ngay.",
  "Học từ mới: 'Pain Point' - Nghĩa là 'Chỗ ngứa'. Gãi đúng chỗ này thì khách sướng, khách chi tiền.",
  "Học từ mới: 'Cold Call' - Cuộc gọi lạnh lẽo. Nghĩa là gọi xong lòng mình lạnh ngắt vì bị khách chửi.",

  // =========================================================================
  // PHẦN 4: LỜI KHUYÊN TỪ "NGƯỜI TỪNG TRẢI" (BEEN THERE, DONE THAT)
  // =========================================================================
  "Uống nước nhớ nguồn. Chốt được đơn nhớ mời anh em trà sữa. Ăn một mình đau bụng đấy.",
  "Đừng mang việc về nhà. Nhà là để ngủ, không phải để nghe khách phàn nàn. Tắt máy, bật chế độ 'Vợ/Chồng là nhất'.",
  "Thứ 2 là ngày đầu tuần, hứa cố gắng chăm ngoan. Thứ 3, thứ 4, thứ 5... thôi để tuần sau cố gắng tiếp.",
  "Sếp không phải lúc nào cũng đúng. Nhưng sếp là người trả lương. Nên sếp luôn... hợp lý.",
  "Đừng nhìn vào thành công của người khác. Nhìn vào đống nợ của mình mà lấy động lực kìa.",
  "Cà phê không giúp em tỉnh táo đâu. Tin nhắn 'Tài khoản +10.000.000 VNĐ' mới giúp em tỉnh táo.",
  "Giữ cái đầu lạnh và trái tim nóng. Chứ đầu nóng mà tim lạnh là... đột quỵ đấy.",
  "Cuối cùng: Anh Mạnh ở đây là để giúp, không phải để làm hộ. Hỏi thì hỏi, đừng có quăng link bảo anh đọc dùm!",

  // =========================================================================
  // PHẦN 5: TIẾNG ANH BỒI CHO DÂN SALES (CHEAPO ENGLISH TEACHER)
  // =========================================================================
  "Tiếng Anh Bồi: 'Follow up' (Bám sát). Đừng để khách nguội lạnh. Ví dụ: 'Alo anh ơi, em follow up cái báo giá hôm qua xem anh duyệt chưa ạ?'",
  "Tiếng Anh Bồi: 'Deadline' (Hạn chót). Đừng đọc là 'Đét-lai' nha. Ví dụ: 'Sếp dí deadline sát đít rồi, chạy thôi anh em!'",
  "Tiếng Anh Bồi: 'Ghosting' (Bơ toàn tập). Chỉ việc khách xem tin nhắn mà im re. Ví dụ: 'Buồn quá anh ơi, khách ghost em 3 ngày nay rồi.'",
  "Tiếng Anh Bồi: 'Win-Win' (Đôi bên cùng sướng). Ví dụ: 'Deal này phải Win-Win, anh vui vẻ, em có cháo ăn.'",
  "Tiếng Anh Bồi: 'Budget' (Ngân sách/Túi tiền). Ví dụ: 'Khéo léo check xem budget khách tầm bao nhiêu để tư vấn cho chuẩn, đỡ phí nước bọt.'",
  "Tiếng Anh Bồi: 'Feedback' (Phản hồi). Khen chê gì cũng quý. Ví dụ: 'Chị ơi lắp xong cho em xin cái feedback 5 sao để em về lòe sếp tăng lương nhé!'",
  "Tiếng Anh Bồi: 'ASAP' (As Soon As Possible - Ngay và luôn). Ví dụ: 'Gửi báo giá ASAP nha em, khách đang cần gấp lắm rồi!'",
  "Tiếng Anh Bồi: 'Discount' (Giảm giá). Ví dụ: 'Khách đòi discount sâu quá, em có nên cắt máu hoa hồng không anh?' (Trả lời: Không nhé!)",
  "Tiếng Anh Bồi: 'Commission' (Hoa hồng). Động lực đi làm là đây. Ví dụ: 'Ca này commission thơm phức, anh em cày nhiệt tình vào!'",
  "Tiếng Anh Bồi: 'Confirm' (Xác nhận). Nói mồm không tin được. Ví dụ: 'Anh confirm vào email giúp em để em báo kho xuất hàng nhé.'",
  "Tiếng Anh Bồi: 'Potential' (Tiềm năng). Ví dụ: 'Khách này nhìn potential lắm, đi xe sang, dùng đồ hiệu, chăm kỹ vào!'",
  "Tiếng Anh Bồi: 'Networking' (Tạo mối quan hệ). Ví dụ: 'Tối nay đi networking (đi nhậu) với mấy anh bên thiết kế không?'",
  "Tiếng Anh Bồi: 'Target' (Chỉ tiêu). Con số ám ảnh. Ví dụ: 'Tháng này anh em mình về số (đạt target) sớm thì sếp mời đi lẩu.'",
  "Tiếng Anh Bồi: 'Proposal' (Đề xuất/Phương án). Ví dụ: 'Em gửi cái proposal xịn sò này sang là khách gật đầu cái rụp.'",
  "Tiếng Anh Bồi: 'Decision Maker' (Người quyết định). Ví dụ: 'Đừng tốn công tư vấn cho nhân viên, tìm ông Decision Maker (Sếp) mà đánh.'",
  "Tiếng Anh Bồi: 'Closing' (Chốt hạ). Ví dụ: 'Kỹ năng closing của em còn non lắm, tối sang nhà anh... dạy kèm cho.' (Đùa thôi!)",
  "Tiếng Anh Bồi: 'Telesales' (Gọi điện chào hàng). Ví dụ: 'Telesales là phải lì, bị chửi không được quạu, cứ cười tươi mà gọi tiếp.'",
  "Tiếng Anh Bồi: 'Soft Skill' (Kỹ năng mềm). Ví dụ: 'Cười duyên, nói ngọt cũng là một loại soft skill thượng thừa đấy.'",
  "Tiếng Anh Bồi: 'Promotion' (Khuyến mãi). Ví dụ: 'Anh ơi, chương trình promotion này chỉ còn hôm nay thôi, anh chốt luôn kẻo lỡ.'",
  "Tiếng Anh Bồi: 'Pain Point' (Nỗi đau của khách). Tìm ra chỗ ngứa mà gãi. Ví dụ: 'Pain point của khách là sợ hàng rởm, em cam kết bảo hành mạnh vào.'",
  "Tiếng Anh Bồi: 'Kick-off' (Khởi động). Ví dụ: 'Mai kick-off dự án mới, anh em nhớ đi đầy đủ lấy khí thế nhé!'"
];

// 6 Days in milliseconds
const MEMORY_EXPIRY_MS = 6 * 24 * 60 * 60 * 1000;
const STORAGE_KEY = "tieu_manh_history_v1";

export default function SalesChatWidget({ className, style }) {
  const messagesRef = useRef(null);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation(); // Hook to watch navigation

  // 2. MEMORY LOADER (On component mount)
  const [messages, setMessages] = useState(() => {
    // Generate a Fresh Quote for THIS session/reload
    const randomQuote = WISDOM_QUOTES[Math.floor(Math.random() * WISDOM_QUOTES.length)];

    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        const age = Date.now() - (parsed.timestamp || 0);
        // If memory is fresh (< 6 days), load it
        if (age < MEMORY_EXPIRY_MS && Array.isArray(parsed.data) && parsed.data.length > 0) {
           // Clone to allow modification
           const history = [...parsed.data];
           const lastMsg = history[history.length - 1];

           const newWisdomMsg = {
             role: "assistant",
             html: `<div><strong>😎 Tiểu Mạnh:</strong> Mừng bạn quay lại!</div>
                    <div style="margin-top:6px"><em>"${randomQuote}"</em></div>`
           };

           // FEATURE UPDATE: Append wisdom to the END so user sees it immediately.
           // Anti-Spam Logic: If the last message was ALREADY a "Welcome back" wisdom,
           // replace it (update the quote) instead of adding a new row.
           if (lastMsg.role === "assistant" && lastMsg.html.includes("Mừng bạn quay lại!")) {
             history[history.length - 1] = newWisdomMsg;
           } else {
             history.push(newWisdomMsg);
           }
           
           return history;
        }
      }
    } catch (e) {
      console.error("Memory load failed", e);
    }
    
    // Default Start (No History)
    return [
      {
        role: "assistant",
        html: `<div><strong>😎 Tiểu Mạnh:</strong> Chào đồng chí!</div>
               <div style="margin-top:6px"><em>"${randomQuote}"</em></div>
               <div style="margin-top:6px">Nay có ca nào khó cần Tiểu Mạnh tư vấn, hay cần tra cứu gì không?</div>`
      }
    ];
  });

  // 3. AUTO-SAVE MEMORY (Whenever messages change)
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        data: messages
      }));
    } catch (e) {}
    
    // Scroll to bottom
    const el = messagesRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages]);

  // 4. WATCH FOR NAVIGATION (Refresh Wisdom if component reused)
  const prevPath = useRef(location.pathname);
  useEffect(() => {
    if (prevPath.current !== location.pathname) {
        prevPath.current = location.pathname;
        
        // Generate NEW random quote
        const randomQuote = WISDOM_QUOTES[Math.floor(Math.random() * WISDOM_QUOTES.length)];
        const newWisdomMsg = {
             role: "assistant",
             html: `<div><strong>😎 Tiểu Mạnh:</strong> Mừng bạn quay lại!</div>
                    <div style="margin-top:6px"><em>"${randomQuote}"</em></div>`
        };

        setMessages((prev) => {
            if (!prev || prev.length === 0) return prev;
            
            const history = [...prev];
            const lastMsg = history[history.length - 1];
            
            // Same logic: Replace if last was welcome, else append
            if (lastMsg && lastMsg.role === "assistant" && lastMsg.html.includes("Mừng bạn quay lại!")) {
                 history[history.length - 1] = newWisdomMsg;
            } else {
                 history.push(newWisdomMsg);
            }
            return history;
        });
    }
  }, [location.pathname]);

  // Helpers
  function pushUser(text) {
    const newMsg = { role: "user", html: `<strong>Bạn:</strong> <span>${escapeHtml(text)}</span>` };
    setMessages((prev) => [...prev, newMsg]);
    return newMsg;
  }
  
  function pushAssistant(html, rawText) {
    setMessages((prev) => [...prev, { role: "assistant", html, rawText }]);
  }
  
  function escapeHtml(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  // Clear History Function
  function clearMemory() {
    if(!window.confirm("Xóa hết tin nhắn cũ hả em?")) return;
    localStorage.removeItem(STORAGE_KEY);
    const randomQuote = WISDOM_QUOTES[Math.floor(Math.random() * WISDOM_QUOTES.length)];
    setMessages([{
      role: "assistant",
      html: `<div><strong>😎 Tiểu Mạnh:</strong> Ok, trang giấy trắng!</div>
             <div style="margin-top:4px"><em>"${randomQuote}"</em></div>`
    }]);
  }

  // Function to play audio
  async function playVoice(text) {
    if (!text) return;
    try {
      // Show a temporary loading indicator if you want, or just wait
      const r = await fetch("/api/packestimate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text, mode: "speak" }), // Request Audio
      });
      const data = await r.json();
      if (data.ok && data.audio) {
        const audio = new Audio("data:audio/mp3;base64," + data.audio);
        audio.play();
      }
    } catch (err) {
      console.error("Audio error", err);
    }
  }
  
  async function handleSubmit(e) {
    e?.preventDefault?.();
    const text = input.trim();
    if (!text || loading) return;

    pushUser(text);
    setInput("");
    setLoading(true);

    try {
      // 4. SEND HISTORY TO BACKEND
      // We strip the HTML to save tokens, sending only raw text content if available, or stripping tags
      const historyPayload = messages.map(m => ({
        role: m.role,
        content: m.rawText || m.html.replace(/<[^>]+>/g, "").replace("😎 Tiểu Mạnh:", "").replace("Bạn:", "").trim()
      }));

      const r = await fetch("/api/packestimate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          text, 
          mode: "sales",
          history: historyPayload // <--- Sending memory context
        }),
      });
      const data = await r.json();

      if (!data.ok) {
        pushAssistant(`<span style="color:#c1121f">⚠️ Mạng lag rồi, thử lại đi em!</span>`);
      } else {
        
        // FIX: Parse Markdown links & Smart Fallback for Lazy AI
        let processedReply = (data.reply || "");

        // 1. Markdown Links: [Title](URL) - This works if AI sends correct format
        processedReply = processedReply.replace(
          /\[([^\]]+)\]\s*\(([^)]+)\)/g, 
          '<a href="$2" target="_blank" rel="noopener noreferrer" style="color:#0056b3;text-decoration:underline;">$1</a>'
        );

        // 2. Fallback: Raw URLs (http...)
        processedReply = processedReply.replace(
          /(?<!href="|">)(https?:\/\/[^\s<]+)/g, 
          '<a href="$1" target="_blank" rel="noopener noreferrer" style="color:#0056b3;text-decoration:underline;">$1</a>'
        );

        // 3. LAZY AI FALLBACK: Detect "Bấm vào đây..." with NO LINK and generate one using USER'S QUESTION
        // Checks for "Bấm vào đây để tra Google" NOT inside an existing <a> tag.
        processedReply = processedReply.replace(
          /(<a[^>]*>.*?<\/a>)|((?:👉|👇|☞)?\s*Bấm vào đây để tra Google)/gi,
          (match, existingLink, lazyText) => {
            // If it was already a link (Group 1), keep it.
            if (existingLink) return existingLink; 
            
            // If it was just text (Group 2), wrap it in a Google Search link for the USER'S query
            const query = encodeURIComponent(text); 
            return `<a href="https://www.google.com/search?q=${query}" target="_blank" rel="noopener noreferrer" style="color:#0056b3;text-decoration:underline;">${lazyText}</a>`;
          }
        );

        pushAssistant(
          `<strong>😎 Tiểu Mạnh:</strong><div style="white-space:pre-wrap;margin-top:4px;color:#333;line-height:1.4;">${processedReply}</div>`, 
          data.raw_reply 
        );
      }

    } catch (err) {
      pushAssistant(`⚠️ Lỗi: ${escapeHtml(err.message)}`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={`sc-widget ${className || ""}`} style={style}>
      <style>{`
        .sc-widget { 
          display: flex; flex-direction: column; 
          background: #fff; border: 1px solid #ddd; border-radius: 10px; 
          overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          height: 380px; /* Increased height slightly */
        }
        .sc-messages { 
          flex: 1; padding: 12px; overflow-y: auto; font-size: 13px; background: #fff; 
          border-bottom: 1px solid #eee;
        }
        .sc-msg { margin-bottom: 10px; line-height: 1.4; }
        .sc-msg strong { color: #0056b3; margin-right: 4px; }
        .sc-input { display: flex; gap: 6px; padding: 8px; background: #f9f9f9; }
        .sc-field { flex: 1; padding: 6px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 13px; }
        .sc-clear { background: none; border: none; font-size: 11px; color: #999; cursor: pointer; margin-left: auto; }
        .sc-clear:hover { color: #d32f2f; }
      `}</style>

      {/* Header */}
      <div style={{background: '#f0f7ff', padding: '8px 12px', borderBottom:'1px solid #e1ecf7', fontSize:'13px', color:'#0056b3', fontWeight:'600', display:'flex', alignItems:'center', gap:'6px'}}>
        <span>💬 Trợ Lý Sales: Tiểu Mạnh</span>
        <button className="sc-clear" onClick={clearMemory} title="Xóa lịch sử chat">🗑️ Reset</button>
      </div>

      <div className="sc-messages" ref={messagesRef}>
        {messages.map((m, i) => (
          <div key={i} className="sc-msg">
            {/* 1. The Message Text */}
            <div dangerouslySetInnerHTML={{ __html: m.html }} />

            {/* 2. The Speaker Button (Only for Tiểu Mạnh) */}
            {m.role === "assistant" && (
              <button
                onClick={() => {
                  // Strip HTML tags to get clean text for the voice engine
                  const txt = m.rawText || m.html.replace(/<[^>]+>/g, " ").replace("😎 Tiểu Mạnh:", "").trim();
                  playVoice(txt);
                }}
                style={{
                  background: "none", 
                  border: "none", 
                  cursor: "pointer", 
                  fontSize: "16px", 
                  marginTop: "4px", 
                  opacity: 0.6,
                  transition: "opacity 0.2s"
                }}
                onMouseOver={(e) => e.target.style.opacity = 1}
                onMouseOut={(e) => e.target.style.opacity = 0.6}
                title="Nghe 😎 Tiểu Mạnh nói"
              >
                🔊
              </button>
            )}
          </div>
        ))}
        {loading && <div className="sc-msg" style={{fontStyle:"italic", color:"#888"}}>Tiểu Mạnh đang suy nghĩ...</div>}
      </div>

      <form className="sc-input" onSubmit={handleSubmit}>
        <input
          className="sc-field"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Hỏi khó 😎 Tiểu Mạnh đi... (hoặc nhờ 'Tra google...')"
        />
        <Button type="submit" disabled={loading} style={{padding: "4px 10px", fontSize:"13px"}}>
          Gửi
        </Button>
      </form>
    </div>
  );
}